export const getReportDateRange = (days: number) => {
  const today = new Date();
  const startDate = new Date();
  startDate.setDate(today.getDate() - days);
  return {
    start_date: startDate.toISOString().split('T')[0],
    end_date: today.toISOString().split('T')[0],
  };
};

export const formatTimestamp = (timestamp?: string | number) => {
  if (!timestamp || timestamp === 'N/A') return '';
  const date = new Date(+timestamp);
  return date.toISOString().replace('T', ' ').split('.')[0];
};

export const getDirectoryPath = (path: string): string => {
  if (!path) return '';
  const separator = path.includes('/') ? '/' : '\\';

  const segments = path.split(/[/\\]/);
  segments.pop();

  return segments.join(separator) + separator;
};
